export default function SubscribeSection() {
  return (
    <section id="subscribe" className="relative py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-2xl overflow-hidden border border-white/10">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-1/2 h-64 lg:h-auto overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20with%20glowing%20red%20text%20breaking%20news%20concept%2C%20film%20grain%20texture%2C%20artistic%20abstract%20photography%2C%20mysterious%20atmosphere%2C%20dark%20background%2C%20editorial%20style%2C%20cinematic%20lighting%2C%20high%20contrast%2C%20noir%20aesthetic&width=900&height=700&seq=subscribe-cta-2026&orientation=landscape"
                alt="51爆料网订阅 - 吃瓜不停"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            <div className="lg:w-1/2 flex items-center p-8 md:p-14">
              <div className="w-full">
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 leading-tight mb-4">
                  吃瓜<span className="text-primary-400 italic">不停</span>
                  <br />
                  关注51爆料网
                  <br />
                  <span className="text-foreground-500">后续更新</span>
                </h2>

                <p className="text-foreground-500 text-sm leading-relaxed mb-8">
                  订阅51爆料网每日推送，第一时间获取最新娱乐八卦、明星黑料、独家内幕。吃瓜快人一步！
                </p>

                <form
                  id="subscribe-form"
                  className="flex flex-col sm:flex-row gap-3"
                  data-readdy-form=""
                  method="POST"
                  action="https://readdy.ai/api/form/d92d1bg0sqa2sn3dnfbg"
                >
                  <input
                    type="email"
                    name="email"
                    placeholder="输入您的邮箱地址"
                    required
                    className="flex-1 px-4 py-3 bg-background-200/70 border border-background-300/40 rounded-full text-foreground-200 text-sm placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                  />
                  <div className="field-alt">
                    <input
                      type="text"
                      name="website_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                    />
                  </div>
                  <button
                    type="submit"
                    className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
                  >
                    立即订阅
                  </button>
                </form>

                <p className="text-foreground-600 text-xs mt-3">
                  订阅即表示同意我们的隐私政策，我们承诺不会泄露您的邮箱信息。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}